import { useEffect, useState } from 'react';

import esES from 'antd/lib/locale/es_ES';
import ptBR from 'antd/lib/locale/pt_BR';
import { Config } from 'react-translator-component';

import grayPoint from './assets/grayPoint.png';
import greenPoint from './assets/greenPoint.png';
import localeEnUS from './locale/en_US';
import localeEsCO from './locale/es_CO';
import localeEsEC from './locale/es_EC';
import localeEsUY from './locale/es_UY';
import localePtBR from './locale/pt_BR';

Config.list = {
  en: {
    text: 'English',
    icon: grayPoint,
    file: localeEnUS,
  },
  br: {
    text: 'Português',
    icon: greenPoint,
    file: localePtBR,
  },
  es_co: {
    text: 'Español',
    icon: greenPoint,
    file: localeEsCO,
  },
  es_ec: {
    text: 'Español',
    icon: greenPoint,
    file: localeEsEC,
  },
  es_uy: {
    text: 'Español',
    icon: greenPoint,
    file: localeEsUY,
  },
};

export const useApp = () => {
  const [antdLibLanguage, setAntdLibLanguage] = useState(ptBR);
  const [rtcLang, setRtcLibLanguage] = useState<string>('');

  useEffect(() => {
    fetch(window.location.href).then((response) => {
      let headerApiKey = response.headers.get('Api-Key');

      let headerTheme = response.headers.get('Theme');

      const headerTermsOfUse = response.headers.get('Terms-Of-Use');

      let headerDeepLinkingHost = response.headers.get('Deeplinking-Host');

      const environment = response.headers.get('Environment');

      let headerTerminalPaymentHost = response.headers.get(
        'TerminalPayment-Host',
      );

      if (!headerApiKey) {
        headerApiKey = process.env.REACT_APP_TENANT_KEY as string;
      }

      if (!headerTheme) {
        headerTheme = process.env.REACT_APP_THEME as string;
      }

      if (!headerDeepLinkingHost) {
        headerDeepLinkingHost = `lk-${headerTheme}.use-move.com`;
      }

      if (!headerTerminalPaymentHost) {
        if (headerTheme === 'intelbras') {
          headerTerminalPaymentHost =
            'terminal-pagamento.intelbras-cve-pro.com.br';
        } else {
          headerTerminalPaymentHost = `terminal-${headerTheme}.use-move.com.br`;
        }
      }

      localStorage.setItem('api-key', headerApiKey);
      localStorage.setItem('theme', headerTheme);
      localStorage.setItem('deeplinking-host', headerDeepLinkingHost);
      localStorage.setItem('terminalpayment-host', headerTerminalPaymentHost);
      localStorage.setItem('environment', environment);

      if (
        headerTermsOfUse != null &&
        headerTermsOfUse.length != 0 &&
        headerTermsOfUse.trim()
      ) {
        localStorage.setItem('terms-of-use', headerTermsOfUse);
      }

      let tenantLanguage = 'br';

      switch (headerTheme) {
        case 'terpel':
        case 'test-terpel':
          tenantLanguage = 'es_co';

          setAntdLibLanguage(esES);

          break;
        case 'terpel_equador':
          tenantLanguage = 'es_ec';

          setAntdLibLanguage(esES);

          break;
        case 'intelbras_uruguai':
          tenantLanguage = 'es_uy';

          setAntdLibLanguage(esES);

          break;
        default:
          break;
      }

      localStorage.setItem('rtc-lang', tenantLanguage);

      setRtcLibLanguage(tenantLanguage);

      const favicon = <HTMLLinkElement>document.getElementById('favicon');

      if (favicon) {
        favicon.href = `https://storage.googleapis.com/mk-move-repository/white-label/${headerTheme}/images/dash-favicon.png`;
      }

      document.title = 'Dashboard';
    });
  }, []);

  return { antdLibLanguage, rtcLang };
};
